import { type AxiosRequestConfig } from 'axios'
import { ENVIRONMENT } from './environment.config'

const state = { hasNavigatedInApp: false }

export const markInternalNavigation = () => {
  state.hasNavigatedInApp = true
}

export const navigationSource = () =>
  state.hasNavigatedInApp ? 'internal' : 'external'

const targetsOurServer = (config: AxiosRequestConfig) =>
  (config.baseURL ?? config.url ?? '').startsWith(ENVIRONMENT.SERVER_URL)

export const attachNavigationSource = (config: AxiosRequestConfig) =>
  targetsOurServer(config)
    ? {
        ...config,
        headers: { ...config.headers, 'x-navigation-source': navigationSource() },
      }
    : config
